var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"loding",staticStyle:{"height":"400px"},attrs:{"justify":"center","align":"center"}},[_c('div',{staticClass:"lds-spinner"},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])])
}
var staticRenderFns = []

export { render, staticRenderFns }